import {
  GridRowModes,
  GridRowModesModel,
  GridRowsProp,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import { v4 as uuidv4 } from "uuid";
import { Row } from "../types";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { isRegion, REGIONS_NAME } from "../../../config";

interface EditToolbarProps {
  setRows: (newRows: (oldRows: GridRowsProp<Row>) => GridRowsProp<Row>) => void;
  setRowModesModel: (
    newModel: (oldModel: GridRowModesModel) => GridRowModesModel
  ) => void;
}

function EditToolbar(props: EditToolbarProps) {
  const { setRows, setRowModesModel } = props;
  const { t } = useTranslation();
  const {
    countriesAll: { data: countriesAllData },
  } = useSelector((state: RootState) => state);

  const fittedCountry = countriesAllData.find(
    (country) =>
      country.country_name.toUpperCase() ===
        (isRegion.latam ? REGIONS_NAME.LATAM : 
         isRegion.romania ? REGIONS_NAME.ROMANIA : 
         REGIONS_NAME.USA)
  );

  const handleClick = () => {
    const id = uuidv4();
    fittedCountry &&
      setRows((oldRows) => [
        ...oldRows,
        {
          id,
          email: "",
          password: "",
          region_id: fittedCountry.region_id,
          name: "",
          surname: "",
          countries: [fittedCountry.id],
          isActive: true,
          isAdmin: false,
          isNew: true,
        },
      ]);
    setRowModesModel((oldModel) => ({
      ...oldModel,
      [id]: { mode: GridRowModes.Edit, fieldToFocus: "email" },
    }));
  };

  return (
    <GridToolbarContainer>
      <Button
        color="secondary"
        startIcon={<AddIcon />}
        onClick={handleClick}
        children={t("adminPanel.add_user")}
      />
    </GridToolbarContainer>
  );
}

export default EditToolbar;
